import { PLATFORM } from 'Constants/device.APP_TARGET';

export const PRICE_API_VERSION = '1.0.0';

export const API_PATH = {
    FORM_FIELDS: '/api/rocket/valuate/form-fields',
    GET_VALUES: '/api/rocket/valuate',
    PRICE_PREDICTION: `/api/rocket/valuate/predict?version=${PRICE_API_VERSION}&platform=web-${PLATFORM}`,
    LEAD_API: '/api/inspection/user/lead',
    REGISTRATION_DETAILS: '/api/rocket/inspection/car/data',
    REGISTRATION_DETAILS_V2: '/api/v2/rocket/valuate/rc',
    LOADER_DATA: '/api/rocket/metrics/inspection',
    TRUECALLER_DATA: '/api/inspection/user/truecaller/userInfo',
    CAR_BUYABLE_API: '/api/rocket/valuate/variant'
};

export const PANAMERA_CLIENT = {
    'X-PANAMERA-CLIENT-ID': `web-${PLATFORM}`
};

export const SI_FLOW_START_COOKIE = 'SI_INIT';

export const VALUATION_FORM_REGISTRATION = 'VALUATION_FORM_REGISTRATION';
export const VALUATION_FORM_FIELDS = 'VALUATION_FORM_FIELDS';
export const VALUATION_FORM_DATA_VALUES = 'VALUATION_FORM_DATA_VALUES';
export const VALUATION_FORM_PRICE_PREDICTION = 'VALUATION_FORM_PRICE_PREDICTION';
export const VALUATION_FORM_LEAD_ID = 'VALUATION_FORM_LEAD_ID';
export const VALUATION_COMPLETE = 'valuation_complete';
export const VALUATION_USER_CONTACT_DETAILS = 'valuation_user_contact_details';
export const VALUATION_USER_OTP_POPUP_SHOWN = 'valuation_user_otp_popup_shown';

export const FIELD_CONSTANTS = {
    VALUATION_USER_VALUES: 'valuationUserValues',
    VALUATION_PRIDICTED_PRICE: 'valuationPredictedPrice',
    LEAD_ID: 'lead_id',
    NINETY: 90,
    SIXTY: 60,
    PHONE_KEY: 'phone',
    MAKE_KEY: 'make',
    NAME_KEY: 'name',
    MILEAGE_KEY: 'mileage',
    VARIANT_KEY: 'variant',
    TRIM_KEY: 'trim',
    YEAR_KEY: 'year',
    REGISTERED_STATE_KEY: 'registeredState',
    EMAIL_KEY: 'email',
    AREA_KEY: 'area',
    AUTOS_VALUATION_ROUTE: '/sell-car',
    DISPLAY_VALUE: 'displayValue',
    VALUATION_CROSS_ROUTE: '/',
    VALUATION_FLOW_PATH_V2: 'valuationFlow',
    LAST_SELECTED_SECTION: 'lastSelectedSection',
    NUMBER_PLATE: 'numberPlate',
    MODEL_KEY: 'model',
    EMAIL_DETAILS: 'email_details',
    PHONE_DETAILS: 'phone_details',
    NAME_DETAILS: 'name_details',
    FIRST_OWNER: 'first_owner',
    TRANSMISSION: 'transmission',
    RC_NUMBER: 'rc_number',
    BODY_TYPE: 'bodyType',
    FACE_LIFT: 'faceLift',
    SEAT_TYPE: 'seat',
    ENGINE_TYPE: 'engine',
    WHEEL_DRIVE: 'wheelDrive',
    PLATE_TYPE: 'plate',
    PREFERRED_NAME_KEY: 'preferred_name',
    PREFERRED_EMAIL_KEY: 'preferred_email',
    SELL_URGENCY_KEY: 'sellingUrgency'
};

export const STRLEN = 56;

export const FLOW_REDUCERS_TYPE = {
    UPDATE_SHOW_ALL_HP: 'UPDATE_SHOW_ALL_HP',
    UPDATE_SHOWL_ALL_VAL_PAGE: 'UPDATE_SHOWL_ALL_VAL_PAGE',
    RECEIVE_VALUATION_FORM_FIELDS: 'RECEIVE_VALUATION_FORM_FIELDS',
    RECEIVE_VALUATION_FORM_DATA_VALUES_MAKE: 'RECEIVE_VALUATION_FORM_DATA_VALUES_MAKE',
    IS_REGISTRATION_API_CALLED: 'IS_REGISTRATION_API_CALLED',
    EXPONEA_QUOTE_PAGE_EVENT_CALLED: 'EXPONEA_QUOTE_PAGE_EVENT_CALLED',
    RECEIVE_VALUATION_FORM_REGISTRATION: 'RECEIVE_VALUATION_FORM_REGISTRATION'
};

export const SHOW_ALL_BTN_KEY = 'showAll';

export const STATIC_HEADING = {
    make: 'make',
    model: 'model',
    variant: 'variant',
    registeredState: 'registeredState',
    year: 'year',
    first_owner: 'first_owner',
    mileage: 'mileage',
    phone: 'enterContactDetails'
};

export const ROUTES = {
    VALUATION_FLOW: '/valuation-flow',
    HOME_PAGE: '/',
    SELL_CAR: '/sell-car',
    SELL_CAR_INSTANTLY: '/sell-my-car/instant-payment'
};

export const TRACKING_EVENTS = {
    name: {
        VALUATION_PAGE_OPEN: 'valuation_page_open',
        VALUATION_BACK_PRESS: 'valuation_tap_back',
        VALUATION_CROSS_PRESS: 'valuation_tap_close',
        VALUATION_ATTRIBUTE_SELECT: 'valuation_attribute_select',
        VALUATION_ATTRIBUTE_COMPLETE: 'valuation_attribute_complete',
        VALUATION_VALUE_CAR: 'valuation_tap_value_my_car',
        VALUATION_ERROR_SHOWN: 'valuation_error_shown',
        VALUATION_CLOSE_DROPDOWN: 'valuation_tap_close_dropdown',
        VALUATION_PRICES_SHOWN: 'valuation_prices_shown',
        VALUATION_TAP_NEXT: 'valuation_tap_next',
        VALUATION_EDIT_CAR_DETAILS: 'valuation_tap_edit_car_details',
        VALUATION_NO_PRICE_QUOTE: 'valuation_no_quote_generated',
        BOOK_APPOINTMENT_EMAIL_COMPLETE_ERROR: 'book_appointment_email_complete_error',
        BOOK_APPOINTMENT_EMAIL_COMPLETE: 'book_appointment_email_complete',
        BOOK_APPOINTMENT_PHONE_COMPLETE_ERROR: 'book_appointment_phone_complete_error',
        BOOK_APPOINTMENT_PHONE_COMPLETE: 'book_appointment_phone_complete',
        BOOK_APPOINTMENT_NAME_COMPLETE: 'book_appointment_name_complete',
        VALUATION_TAB_ATTRIBUTE: 'valuation_tap_attribute',
        VALUATION_LEAD_CREATED: 'valuation_lead_created',
        VALUATION_TAB_SEE_MORE: 'valuation_tap_see_more',
        VALUATION_TAP_TOOLTIP: 'valuation_tap_tooltip',
        VALUATION_TAP_TOOLTIP_CLOSE: 'valuation_tap_tooltip_close',
        VALUATION_SEARCH_START: 'valuation_search_start',
        VALUATION_TAP_TNC_CHECKBOX: 'valuation_tap_tnc_checkbox',
        VALUATION_ZOOP_ATTRIBUTE_FETCHED: 'valuation_zoop_attribute_fetched',
        VALUATION_ZERO_SEARCH_RESULT: 'valuation_search_zero_results',
        VALUATION_TRUECALLER_NUM_EXISTS: 'valuation_truecaller_num_exists',
        VALUATION_TRUECALLER_NUM_ACCEPT: 'valuation_truecaller_num_accept',
        VALUATION_TRUECALLER_NUM_REJECT: 'valuation_truecaller_num_reject',
        VALUATION_BEYOND_LIMIT: 'valuation_beyond_limit',
        VALUATION_TAP_WHATSAPP_BUTTON: 'valuation_tap_whatsapp_button',
        VALUATION_OTP_PAGE_OPEN: 'valuation_otp_page_open'
    },
    origin: {
        val: 'homepage_widget'
    },
    flow: {
        old: 'instant_sell_new_booking_draft',
        'new': 'instant_sell_new_booking_no_draft'
    },
    page: {
        carDetails: 'valuation_car_details',
        carDetailsFilled: 'valuation_car_details_filled',
        valuationLoaderPage: 'valuation_loader_page'
    },
    field: {
        bookingIndexId: 'booking_index_id'
    }
};

export const REGISTRATION_NUMBER_REGEX_DEFAULT = /^\b(?!.*?\s{2})[A-Za-z0-9 ]{6,}$/;

export const TWO_ROWS_SECTION = [FIELD_CONSTANTS.MODEL_KEY, FIELD_CONSTANTS.VARIANT_KEY, FIELD_CONSTANTS.MILEAGE_KEY];

export const DATA_AUT_IDS = {
    EMAIL_INPUT_ERROR: 'email_input_error',
    PHONE_INPUT_ERROR: 'phone_input_error',
    RETRY_BTN: 'retry_btn',
    RC_ERROR: 'rc_error',
    RC_DETAILS_NOT_FOUND_ERROR: 'rc_details_not_found_error',
    SEL_ATTR: 'sel_attr',
    SHOW_CAR_DETAILS_LINK: 'show_car_details_link',
    MODAL_SEL_ATTR: 'modal_sel_attr'
};

export const MODAL_CLICKS = {
    UNDERSTOOD: 'understood',
    CLOSE: 'close',
    SWIPE_DOWN: 'swipe_down'
};

export const trimOrder = [
    `${FIELD_CONSTANTS.FACE_LIFT}`,
    `${FIELD_CONSTANTS.SEAT_TYPE}`,
    `${FIELD_CONSTANTS.ENGINE_TYPE}`,
    `${FIELD_CONSTANTS.WHEEL_DRIVE}`,
    `${FIELD_CONSTANTS.VARIANT_KEY}`
];

export const EXPONEA_EVENTS = {
    QUOTE_PAGE_OPEN: 'quote_page_open'
};

export const EXPONEA_EVENT_SENDING_SYSTEM_PANAMERA_FRONTEND = 'Panamera - frontend';

export const DEFAULT_SELECTED_TAB = 'default_selected_tab';
export const VALUATION_TABS = {
    CAR_DETAILS: 'car_details',
    RC_NUMBER: 'rc_number'
};

export const CAR_REGISTRATION_NUMBER = 'carRegistrationNumber';

export const PREV_SEO_PATH = 'prevSeoPath';

export const FIELDS_TRANSLATION_ID_MAPPING = {
    make: 'allBrand',
    model: 'allModels',
    variant: 'allVariants'
};

export const VALUATION_CAR_REGISTRATION_NO = 'valuation_car_registration_no';

export const SELL_CARS_PARAMS = ['olxin'];

export const FORM_FIELD_API_VERSION_L2Q = 'v2';

export const PRICE_TYPE = {
    SINGLE_PRICE: 'single_price',
    MULTI_PRICE: 'multi_price'
};

export const NUMBER_PLATE_LENGTH = {
    MIN: 7,
    MAX: 8
};

export const PRICE_PREDICTION_LOADER = 'price-prediction-loader';
